import { z } from 'zod';
// Shared between backend (controller DTO + use case input) and frontend
// (apps/admin qr-generator form + api-client). valet-keychain-qr — platform
// (super_admin) issues sequential per-location keychain QR codes.
// Case-sensitive by design: spec "invalid prefix rejected" explicitly
// requires a lowercase prefix like "la" to be REJECTED, not silently
// uppercased and accepted — this MUST mirror the backend QrPrefix value
// object's regex exactly ([A-Z0-9]{2,8}, no case-folding).
const QR_PREFIX_REGEX = /^[A-Z0-9]{2,8}$/;
export const MAX_QR_BATCH_SIZE = 500;
export const CreateQrBatchRequestSchema = z.object({
    quantity: z.number().int().min(1).max(MAX_QR_BATCH_SIZE),
    // Optional — when omitted, the backend reuses the stored Location.qrPrefix.
    prefix: z
        .string()
        .trim()
        .regex(QR_PREFIX_REGEX, 'Prefix must be 2-8 uppercase letters/digits')
        .optional(),
});
export const QrBatchResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    locationId: z.string().uuid(),
    prefix: z.string(),
    rangeStart: z.number().int(),
    rangeEnd: z.number().int(),
    quantity: z.number().int(),
    createdByUserId: z.string().uuid(),
    createdAt: z.string(),
    /** The full generated/reprinted code list, e.g. ["LAX-0001", "LAX-0002", ...]. */
    codes: z.array(z.string()),
});
// List responses omit `codes` — regenerating every batch's full code list on
// every list call would be wasteful; GET /qr-batches/:batchId (reprint)
// returns the full QrBatchResponse shape on demand.
export const QrBatchSummarySchema = QrBatchResponseSchema.omit({ codes: true });
export const ListQrBatchesResponseSchema = z.object({
    batches: z.array(QrBatchSummarySchema),
});
//# sourceMappingURL=qr-batch-schemas.js.map